import { gql } from "apollo-boost";

export const TopPoiQuery = gql`
  query TopPoiQuery($regions: [String], $limit: Int, $locale: Locale = EN_US) {
    destination(ids: $regions, locale: $locale) {
      poi(limit: $limit) {
        id
        content {
          geo {
            name {
              localized
            }
            latitude
            longitude
          }
          asset {
            text(category: MEDIUM) {
              info {
                text
              }
            }
            image(limit: 1) {
              info {
                alt
                url
              }
            }
          }
        }
      }
    }
  }
`;
